import { render, staticRenderFns } from "./MobilePlayPage.vue?vue&type=template&id=c440a536&scoped=true"
import script from "./MobilePlayPage.vue?vue&type=script&lang=js"
export * from "./MobilePlayPage.vue?vue&type=script&lang=js"
import style0 from "./MobilePlayPage.vue?vue&type=style&index=0&id=c440a536&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c440a536",
  null
  
)

export default component.exports